import clsx from "clsx";
import { RadioIcon } from "@/ui/icon/icons/radio-icon/RadioIcon";
import { formatPercent } from "@/utils/number";
import { useCalculator } from "../../hooks/useCalculator";
import type { Calc } from "../../types";
import styles from "./CalculatorPeriod.module.css";

export const CalculatorPeriod: React.FC<Calc.Period.Period> = ({
  id,
  title,
  discount,
}) => {
  const active = useCalculator((state) => state.activePeriod === id);
  const setActivePeriod = useCalculator((state) => state.setActivePeriod);

  return (
    <div
      className={clsx(styles.period, [active && styles.active])}
      onClick={() => setActivePeriod(id)}
    >
      <RadioIcon active={active} />
      <div className={styles.text}>
        {title}{" "}
        {discount !== undefined && (
          <span className={styles.discount}>{formatPercent(discount)}</span>
        )}
      </div>
    </div>
  );
};
